import Highlight from 'components/Highlight';
import Tabs from 'components/Tabs';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HighlightTabs: FunctionComponent<Props> = ({
    children,
    className = '',
    selectedClass,
    testId = TEST_ID
}) => (
    <Tabs className={`${className} ${styles.highlightTabs}`} testId={testId}>
        {children}

        <Highlight className={`${styles.highlight} ${selectedClass}`} />
    </Tabs>
);

export default HighlightTabs;
